"use client";

import { usePathname } from "next/navigation";
import { PageAnalytics } from "@/components/page-analytics";

const CANONICAL_PDP_SEGMENT_COUNT = 4;

export function ProductPageAnalytics() {
  const pathname = usePathname();
  const parts = pathname.split("/").filter(Boolean);

  // Match the GTM bootstrap in components/analytics.tsx. The fifth segment is
  // the legacy article-code route, which redirects to the canonical PDP.
  if (parts[2] !== "product" || parts.length !== CANONICAL_PDP_SEGMENT_COUNT) {
    return null;
  }

  return <PageAnalytics trackPageChanges type="Product Details Page" />;
}
